import { memo } from "react"
import {
	IconAlarmAlertOutline18,
	IconCirclePercentageOutline18,
	IconShieldCheckOutline18,
} from "nucleo-ui-outline-18"

import type { ReportingQueryProps } from "../reporting-query"
import {
	ReportingBarChart,
	ReportingHeatmap,
	ReportingKpiCard,
	ReportingRankedList,
} from "@/components/reporting/charts"
import { api } from "@/lib/api"

export const SlasTab = memo((props: ReportingQueryProps) => {
	const { startDate, endDate, ...filters } = props
	const query = api.workspace.getReportingSlas.useQuery(
		{ startDate, endDate, ...filters },
		{ cacheTime: Infinity, staleTime: 60_000 },
	)
	const data = query.data
	const loading = query.isLoading

	return (
		<div className="space-y-4 p-4 sm:p-6">
			<div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
				<ReportingKpiCard
					label="With SLA"
					value={data?.withSla}
					isLoading={loading}
					Icon={IconShieldCheckOutline18}
					tone="categorical-0"
				/>
				<ReportingKpiCard
					label="Missed"
					value={data?.missed}
					isLoading={loading}
					Icon={IconAlarmAlertOutline18}
					tone="categorical-2"
				/>
				<ReportingKpiCard
					label="Miss rate %"
					value={data?.missRate}
					isLoading={loading}
					Icon={IconCirclePercentageOutline18}
					tone="danger"
				/>
			</div>

			<ReportingBarChart
				title="Missed SLA targets over time"
				description="SLA breach activities per day in the selected range."
				data={(data?.missSeries ?? []).map((p) => ({
					date: p.date,
					value: p.value,
				}))}
				series={[{ key: "value", label: "Misses", tone: "danger" }]}
				isLoading={loading}
			/>

			<div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
				<ReportingHeatmap
					title="Hourly distribution of missed targets"
					cells={data?.missHeatmap ?? []}
					isLoading={loading}
					scale="danger"
				/>
				<ReportingRankedList
					title="Misses by teammate"
					items={data?.byTeammate ?? []}
					isLoading={loading}
					tone="danger"
				/>
			</div>
		</div>
	)
})
